import React from "react";
import { useSuggestions } from "../hooks/useInventory";
import { Tile } from "./views";
import { Store } from "../store";

const Suggestions = ({ item, t } = {}) => {
  const { config } = Store.useState(s => s);
  const theme = config.eshop.theme.selected;

  const columns = theme.settings?.collectionColumns?.desktop || 6;
  const { data, loading } = useSuggestions({
    type: item ? item.type : "ReleaseItem",
    limit: columns,
    genres: item ? item.data.genres : [],
    id: item ? item.id : null
  });

  if (!data || loading) return null;

  const suggestions = data && data.suggestions;

  return (<div className="suggestions">
    <h3>{t("suggestionsHeader")}</h3>
    <div className="content">
      {suggestions.map(s => <Tile key={s._id} item={s} />)}
    </div>
  </div>);
};

export default Suggestions;
